<template>
	<div class="box" style="border-radius: 13px;
    box-shadow: rgb(0 0 0 / 3%) 0px 4px 12px;"  >
		<div class="null-page" v-show="yes"></div>
		
		<el-card class="box-card member-coupon">
			<div slot="header" class="clearfix" style="    font-weight: 500;
    font-size: 16px;" ><span>คูปองของฉัน</span></div>

			<div>

				<div v-loading="loading">
					<el-tabs v-model="couponstatus" @tab-click="handleClickStatus">
						<el-tab-pane label="ไม่ได้ใช้" name="1"></el-tab-pane>
						<el-tab-pane label="ใช้แล้ว" name="2"></el-tab-pane>
						<el-tab-pane label="หมด อายุ" name="3"></el-tab-pane>
					</el-tabs>

					<div class="coupon-wrap">
						<div
							class="text item"
							:class="state == '1' ? 'coupon-not-used' : state == '2' ? 'coupon-used' : 'coupon-expire'"
							v-for="(item, index) in couponList"
							:key="index"
							@click="useCoupon(item)"
						>
							<template>
								<p class="coupon-wrap-money" v-if="item.discount == '0.00' || !item.discount" style="    margin-top: 35px
px
;
    color: #ffff; font-weight: 700;">
									฿
									<span >{{ item.money }}</span>
								</p>
								<p class="coupon-wrap-money" style="    margin-top: 35px
px
;
    color: #ffff; font-weight: 700;" v-else>
									<span>{{ 100-(item.discount*10) }}</span>
									%
								</p>
							</template>
							<p class="coupon-wrap-name">{{ item.platformcoupon_name }}</p>
							<template>
								<p class="coupon-wrap-least coupon-wrap-info" v-if="item.at_least > 0">ต้องซื้อครบ {{ item.at_least }} บาท</p>
								<p class="coupon-wrap-least coupon-wrap-info" v-else>คูปองไม่มีกฏ</p>
							</template>
							<template>
								<p class="coupon-wrap-time coupon-wrap-info" v-if="item.validity_type">วันที่รวบรวม{{ item.fixed_term }}ใช้ได้หลายวัน</p>
								<p class="coupon-wrap-time coupon-wrap-info" v-else>ใช้ได้ถึงวันที่{{ $timeStampTurnTime(item.end_time) }}</p>
							</template>
						</div>

						<div class="empty-text" v-if="couponList.length == 0">{{ text }}</div>
					</div>

					<div class="pager">
						<el-pagination 
							background 
							:pager-count="5" 
							:total="total" 
							prev-text="ก่อน" 
							next-text="ต่อไป" 
							:current-page.sync="currentPage" 
							:page-size.sync="pageSize" 
							@size-change="handlePageSizeChange" 
							@current-change="handleCurrentPageChange" 
							hide-on-single-page
						></el-pagination>
					</div>
				</div>
			</div>
		</el-card>
	</div>	
</template>

<script>
import { couponList } from '@/api/member/member';
import { mapGetters } from 'vuex';

export default {
	name: 'my_coupon',
	components: {},
	data: () => {
		return {
			total: 0,
			currentPage: 1,
			pageSize: 9,
			couponstatus: '1',
			couponList: [],
			type: '',
			state: 1,
			text: 'คุณยังไม่มีคูปอง',
			loading: true,
			yes: true
		};
	},
	created() {
		if (this.addonIsExit && this.addonIsExit.coupon != 1) {
			this.$notify({
				message: 'ไม่ได้ติดตั้งปลั๊กอินคูปอง',
				title: 'คำเตือน',type: 'warning',
				duration: 2000,
				onClose: () => {
					this.$route.push('/member/index');
				}
			});
		} else {
			this.getListData();
		}
	},
	mounted() {
		let self = this;
		setTimeout(function() {
			self.yes = false
		}, 300)
	},
	computed: {
		...mapGetters(['addonIsExit'])
	},
	watch: {
		addonIsExit() {
			if (this.addonIsExit.coupon != 1) {
				this.$notify({
					message: 'ไม่ได้ติดตั้งปลั๊กอินคูปอง',
					title: 'คำเตือน',type: 'warning',
					duration: 2000,
					onClose: () => {
						this.$route.push('/member/index');
					}
				});
			}
		}
	},
	methods: {
		/**
		 * สถานะคูปอง(ไม่ได้ใช้/ใช้แล้ว/หมด อายุ)
		 */
		handleClickStatus(tab, event) {
			if (tab.name == '1') {
				this.state = 1;
				this.text = 'คุณยังไม่มีคูปอง';
			} else if (tab.name == '2') {
				this.state = 2;
				this.text = 'คุณยังไม่ได้ใช้คูปอง';
			} else {
				this.state = 3;
				this.text = 'คุณยังไม่ได้หมดอายุคูปองของคุณ';
			}
			this.refresh();
		},
		handlePageSizeChange(size) {
			this.pageSize = size;
			this.refresh();
		},
		handleCurrentPageChange(page) {
			this.currentPage = page;
			this.refresh();
		},
		refresh() {
			this.loading = true;
			this.getListData();
		},
		// รับรายการคูปอง
		getListData() {
			couponList({
				page: this.currentPage,
				page_size: this.pageSize,
				state: this.state,
				is_own: this.type,
			})
				.then(res => {
					if (res.code >= 0) {
						this.total = res.data.count;
						this.couponList = res.data.list;
					}
					this.loading = false;
				})
				.catch(err => {
					this.loading = false;
					this.$notify.error({title: 'Error',message: err.message});
				});
		},
		// ไปและใช้คูปอง
		useCoupon(item) {
			if (item.state == 1) {
				if (item.use_scenario != 1) {
					this.$router.push({ path: '/list', query: { coupon: item.coupon_type_id } });
				} else {
					this.$router.push('/list');
				}
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.box {
	width: 100%;
	position: relative;
}

.null-page {
	width: 100%;
	height: 730px;
	background-color: #FFFFFF;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 9;
}

.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
	box-shadow: unset;
}

.el-card {
	border: 0;
}

.coupon-wrap {
	display: flex;
	align-items: center;
	flex-wrap: wrap;

	.text {
		width: 32%;
		height: 140px;
		margin-right: 2%;
		border-radius: 5px;
		border: 1px dashed #fff;
		margin-bottom: 20px;
		padding: 0 15px;
		box-sizing: border-box;
		color: #ffffff;

		.coupon-wrap-money {
			span {
				font-size: 30px;
				margin-right: 5px;
			}
		}

		.coupon-wrap-info {
			font-size: 12px;
			line-height: 18px;
		}
	}

	.text:nth-child(3n) {
		margin-right: 0;
	}

	.coupon-not-used {
		background-color: $base-color;
		cursor: pointer;
	}

	.coupon-used {
		background-color: hsl(360, 50%, 70%);
	}

	.coupon-expire {
		background-color: #d0d0d0;
	}

	.coupon-wrap-info {
		font-size: 12px;
		line-height: 20px;
	}

	.empty-text {
		margin: 0 auto;
	}
}
</style>

<style lang="scss">
.member-coupon {
	.el-tabs__active-bar,
	.el-tabs__nav-wrap::after {
		/* กําจัดtabติดป้ายชื่อเส้นแนวนอนด้านล่าง */
		height: 0;
	}
}.coupon-wrap .text .coupon-wrap-info {
    font-size: 12px;
    line-height: 18px;
    color: #ffff;
}
</style>
